var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1922",
    "data-name": "Group 1922",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.106,
    height: 32.678,
    viewBox: "0 0 26.106 32.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1366",
    "data-name": "Rectangle 1366",
    width: 26.106,
    height: 32.678,
    fill: "none",
    stroke: "#6e6e6e",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1920",
    "data-name": "Group 1920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1920-2",
    "data-name": "Group 1920",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48375",
    "data-name": "Path 48375",
    d: "M20.942,8.823s-6.608,5.125-12.118,5.125V26.939a8,8,0,0,0,2.956,6.5c1.933,1.429,7.707,5.235,7.951,5.4l1.211.8,1.211-.8c.245-.161,6.018-3.968,7.951-5.4a8,8,0,0,0,2.956-6.5V13.948C27.55,13.948,20.942,8.823,20.942,8.823Z",
    transform: "translate(-7.889 -7.888)",
    fill: "none",
    stroke: "#6e6e6e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u20B9",
    transform: "translate(8.553 21.249)",
    fill: "#6e6e6e",
    fontSize: 15,
    fontFamily: "Rubik"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPremium);
export default __webpack_public_path__ + "static/media/Business-Premium.4a79ccfd587e91a8d08a744272562b8d.svg";
export { ForwardRef as ReactComponent };